var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.7 16.8",
    enableBackground: "new 0 0 24.7 16.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M22,16.7H2.7c-1.4,0-2.5-1.1-2.5-2.5V2.6c0-1.4,1.1-2.5,2.5-2.5H22c1.4,0,2.5,1.1,2.5,2.5v11.5 C24.6,15.5,23.4,16.7,22,16.7z M2.7,2.1c-0.3,0-0.5,0.2-0.5,0.5v11.5c0,0.3,0.2,0.5,0.5,0.5H22c0.3,0,0.5-0.2,0.5-0.5V2.6 c0-0.3-0.2-0.5-0.5-0.5H2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M20.1,6.4h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S20.7,6.4,20.1,6.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M7.4,8.9c-1.5,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8S8.9,8.9,7.4,8.9z M7.4,5.3 c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C8.1,5.6,7.8,5.3,7.4,5.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M20.1,9.4h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S20.7,9.4,20.1,9.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M20.1,12.4h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S20.7,12.4,20.1,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M10.1,14c-0.6,0-1-0.4-1-1c0-1-0.8-1.7-1.7-1.7S5.7,12,5.7,13c0,0.6-0.4,1-1,1s-1-0.4-1-1 c0-2.1,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7C11.1,13.5,10.7,14,10.1,14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconId);
export default __webpack_public_path__ + "static/media/icon-id.5b20b2174f3a088d8b92c20c8811e008.svg";
export { ForwardRef as ReactComponent };